// AUTO-GENERATED by scripts/build-icons.mjs — do not edit by hand.
import { createSvgIconFromGenerated } from '../utils'

import SvgBigBag from './svg-big-bag'
import SvgBigBagCrossed from './svg-big-bag-crossed'
import SvgBigBagEmpty from './svg-big-bag-empty'
import SvgBigBank from './svg-big-bank'
import SvgBigBankAdd from './svg-big-bank-add'
import SvgBigBankDecline from './svg-big-bank-decline'
import SvgBigBankDown from './svg-big-bank-down'
import SvgBigBankTransfer from './svg-big-bank-transfer'
import SvgBigBankUp from './svg-big-bank-up'
import SvgBigBusinessExists from './svg-big-business-exists'
import SvgBigCalendar from './svg-big-calendar'
import SvgBigCard from './svg-big-card'
import SvgBigCardAdd from './svg-big-card-add'
import SvgBigCardCrossed from './svg-big-card-crossed'
import SvgBigCardDecline from './svg-big-card-decline'
import SvgBigCardDone from './svg-big-card-done'
import SvgBigCardPending from './svg-big-card-pending'
import SvgBigCart from './svg-big-cart'
import SvgBigCartEmpty from './svg-big-cart-empty'
import SvgBigCash from './svg-big-cash'
import SvgBigCashEmpty from './svg-big-cash-empty'
import SvgBigClock from './svg-big-clock'
import SvgBigContacts from './svg-big-contacts'
import SvgBigContactsAdd from './svg-big-contacts-add'
import SvgBigContactsEmpty from './svg-big-contacts-empty'
import SvgBigContract from './svg-big-contract'
import SvgBigContractDone from './svg-big-contract-done'
import SvgBigContractEmpty from './svg-big-contract-empty'
import SvgBigContractPending from './svg-big-contract-pending'
import SvgBigContractUpload from './svg-big-contract-upload'
import SvgBigContractWarning from './svg-big-contract-warning'
import SvgBigCookies from './svg-big-cookies'
import SvgBigCredits from './svg-big-credits'
import SvgBigCreditsWarning from './svg-big-credits-warning'
import SvgBigDecline from './svg-big-decline'
import SvgBigDelete from './svg-big-delete'
import SvgBigDelivery from './svg-big-delivery'
import SvgBigDirectDebit from './svg-big-direct-debit'
import SvgBigDirectDebitError from './svg-big-direct-debit-error'
import SvgBigDirectDebitSuccess from './svg-big-direct-debit-success'
import SvgBigDivide from './svg-big-divide'
import SvgBigEmail from './svg-big-email'
import SvgBigEmailDeclined from './svg-big-email-declined'
import SvgBigEmailOpen from './svg-big-email-open'
import SvgBigEmailVerified from './svg-big-email-verified'
import SvgBigEmailWarning from './svg-big-email-warning'
import SvgBigFilter from './svg-big-filter'
import SvgBigFingerprint from './svg-big-fingerprint'
import SvgBigGhostDeclined from './svg-big-ghost-declined'
import SvgBigGhostDone from './svg-big-ghost-done'
import SvgBigGhostHappy from './svg-big-ghost-happy'
import SvgBigGhostHelp from './svg-big-ghost-help'
import SvgBigGhostMoney from './svg-big-ghost-money'
import SvgBigGhostPending from './svg-big-ghost-pending'
import SvgBigGhostPendingSuccess from './svg-big-ghost-pending-success'
import SvgBigGhostSad from './svg-big-ghost-sad'
import SvgBigGhostWarning from './svg-big-ghost-warning'
import SvgBigGhost403 from './svg-big-ghost403'
import SvgBigGhost404 from './svg-big-ghost404'
import SvgBigGhost500 from './svg-big-ghost500'
import SvgBigGhost502 from './svg-big-ghost502'
import SvgBigGhost503 from './svg-big-ghost503'
import SvgBigGift from './svg-big-gift'
import SvgBigGraph from './svg-big-graph'
import SvgBigGraphCrossed from './svg-big-graph-crossed'
import SvgBigHide from './svg-big-hide'
import SvgBigHouse from './svg-big-house'
import SvgBigHouseWarning from './svg-big-house-warning'
import SvgBigInsurance from './svg-big-insurance'
import SvgBigInternetBank from './svg-big-internet-bank'
import SvgBigKevinPayment from './svg-big-kevin-payment'
import SvgBigList from './svg-big-list'
import SvgBigLock from './svg-big-lock'
import SvgBigMapPin from './svg-big-map-pin'
import SvgBigMerchant from './svg-big-merchant'
import SvgBigMoney from './svg-big-money'
import SvgBigMoneyCrossed from './svg-big-money-crossed'
import SvgBigNotification from './svg-big-notification'
import SvgBigNotificationCrossed from './svg-big-notification-crossed'
import SvgBigPhone from './svg-big-phone'
import SvgBigPhoneVerification from './svg-big-phone-verification'
import SvgBigPhoneWarning from './svg-big-phone-warning'
import SvgBigPin from './svg-big-pin'
import SvgBigPinDone from './svg-big-pin-done'
import SvgBigPinPending from './svg-big-pin-pending'
import SvgBigPinVisible from './svg-big-pin-visible'
import SvgBigQr from './svg-big-qr'
import SvgBigReceiptAdd from './svg-big-receipt-add'
import SvgBigReceiptEmpty from './svg-big-receipt-empty'
import SvgBigSecurity from './svg-big-security'
import SvgBigSnap from './svg-big-snap'
import SvgBigSnapCrossed from './svg-big-snap-crossed'
import SvgBigSnapEmpty from './svg-big-snap-empty'
import SvgBigTick from './svg-big-tick'
import SvgBigTransfer from './svg-big-transfer'
import SvgBigTwisto from './svg-big-twisto'
import SvgBigUnlock from './svg-big-unlock'
import SvgBigUser from './svg-big-user'
import SvgBigUserAdd from './svg-big-user-add'
import SvgBigUserAttention from './svg-big-user-attention'
import SvgBigUserDecline from './svg-big-user-decline'
import SvgBigUserDone from './svg-big-user-done'
import SvgBigVerification from './svg-big-verification'
import SvgBigWarning from './svg-big-warning'
import SvgBigWorld from './svg-big-world'

export const BigBagIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigBag, 'BigBag')
export const BigBagCrossedIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigBagCrossed, 'BigBagCrossed')
export const BigBagEmptyIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigBagEmpty, 'BigBagEmpty')
export const BigBankIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigBank, 'BigBank')
export const BigBankAddIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigBankAdd, 'BigBankAdd')
export const BigBankDeclineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigBankDecline, 'BigBankDecline')
export const BigBankDownIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigBankDown, 'BigBankDown')
export const BigBankTransferIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigBankTransfer, 'BigBankTransfer')
export const BigBankUpIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigBankUp, 'BigBankUp')
export const BigBusinessExistsIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigBusinessExists, 'BigBusinessExists')
export const BigCalendarIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigCalendar, 'BigCalendar')
export const BigCardIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigCard, 'BigCard')
export const BigCardAddIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigCardAdd, 'BigCardAdd')
export const BigCardCrossedIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigCardCrossed, 'BigCardCrossed')
export const BigCardDeclineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigCardDecline, 'BigCardDecline')
export const BigCardDoneIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigCardDone, 'BigCardDone')
export const BigCardPendingIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigCardPending, 'BigCardPending')
export const BigCartIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigCart, 'BigCart')
export const BigCartEmptyIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigCartEmpty, 'BigCartEmpty')
export const BigCashIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigCash, 'BigCash')
export const BigCashEmptyIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigCashEmpty, 'BigCashEmpty')
export const BigClockIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigClock, 'BigClock')
export const BigContactsIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigContacts, 'BigContacts')
export const BigContactsAddIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigContactsAdd, 'BigContactsAdd')
export const BigContactsEmptyIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigContactsEmpty, 'BigContactsEmpty')
export const BigContractIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigContract, 'BigContract')
export const BigContractDoneIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigContractDone, 'BigContractDone')
export const BigContractEmptyIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigContractEmpty, 'BigContractEmpty')
export const BigContractPendingIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigContractPending, 'BigContractPending')
export const BigContractUploadIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigContractUpload, 'BigContractUpload')
export const BigContractWarningIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigContractWarning, 'BigContractWarning')
export const BigCookiesIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigCookies, 'BigCookies')
export const BigCreditsIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigCredits, 'BigCredits')
export const BigCreditsWarningIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigCreditsWarning, 'BigCreditsWarning')
export const BigDeclineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigDecline, 'BigDecline')
export const BigDeleteIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigDelete, 'BigDelete')
export const BigDeliveryIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigDelivery, 'BigDelivery')
export const BigDirectDebitIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigDirectDebit, 'BigDirectDebit')
export const BigDirectDebitErrorIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigDirectDebitError, 'BigDirectDebitError')
export const BigDirectDebitSuccessIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigDirectDebitSuccess, 'BigDirectDebitSuccess')
export const BigDivideIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigDivide, 'BigDivide')
export const BigEmailIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigEmail, 'BigEmail')
export const BigEmailDeclinedIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigEmailDeclined, 'BigEmailDeclined')
export const BigEmailOpenIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigEmailOpen, 'BigEmailOpen')
export const BigEmailVerifiedIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigEmailVerified, 'BigEmailVerified')
export const BigEmailWarningIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigEmailWarning, 'BigEmailWarning')
export const BigFilterIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigFilter, 'BigFilter')
export const BigFingerprintIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigFingerprint, 'BigFingerprint')
export const BigGhostDeclinedIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigGhostDeclined, 'BigGhostDeclined')
export const BigGhostDoneIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigGhostDone, 'BigGhostDone')
export const BigGhostHappyIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigGhostHappy, 'BigGhostHappy')
export const BigGhostHelpIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigGhostHelp, 'BigGhostHelp')
export const BigGhostMoneyIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigGhostMoney, 'BigGhostMoney')
export const BigGhostPendingIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigGhostPending, 'BigGhostPending')
export const BigGhostPendingSuccessIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigGhostPendingSuccess, 'BigGhostPendingSuccess')
export const BigGhostSadIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigGhostSad, 'BigGhostSad')
export const BigGhostWarningIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigGhostWarning, 'BigGhostWarning')
export const BigGhost403Icon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigGhost403, 'BigGhost403')
export const BigGhost404Icon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigGhost404, 'BigGhost404')
export const BigGhost500Icon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigGhost500, 'BigGhost500')
export const BigGhost502Icon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigGhost502, 'BigGhost502')
export const BigGhost503Icon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigGhost503, 'BigGhost503')
export const BigGiftIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigGift, 'BigGift')
export const BigGraphIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigGraph, 'BigGraph')
export const BigGraphCrossedIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigGraphCrossed, 'BigGraphCrossed')
export const BigHideIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigHide, 'BigHide')
export const BigHouseIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigHouse, 'BigHouse')
export const BigHouseWarningIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigHouseWarning, 'BigHouseWarning')
export const BigInsuranceIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigInsurance, 'BigInsurance')
export const BigInternetBankIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigInternetBank, 'BigInternetBank')
export const BigKevinPaymentIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigKevinPayment, 'BigKevinPayment')
export const BigListIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigList, 'BigList')
export const BigLockIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigLock, 'BigLock')
export const BigMapPinIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigMapPin, 'BigMapPin')
export const BigMerchantIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigMerchant, 'BigMerchant')
export const BigMoneyIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigMoney, 'BigMoney')
export const BigMoneyCrossedIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigMoneyCrossed, 'BigMoneyCrossed')
export const BigNotificationIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigNotification, 'BigNotification')
export const BigNotificationCrossedIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigNotificationCrossed, 'BigNotificationCrossed')
export const BigPhoneIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigPhone, 'BigPhone')
export const BigPhoneVerificationIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigPhoneVerification, 'BigPhoneVerification')
export const BigPhoneWarningIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigPhoneWarning, 'BigPhoneWarning')
export const BigPinIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigPin, 'BigPin')
export const BigPinDoneIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigPinDone, 'BigPinDone')
export const BigPinPendingIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigPinPending, 'BigPinPending')
export const BigPinVisibleIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigPinVisible, 'BigPinVisible')
export const BigQrIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigQr, 'BigQr')
export const BigReceiptAddIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigReceiptAdd, 'BigReceiptAdd')
export const BigReceiptEmptyIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigReceiptEmpty, 'BigReceiptEmpty')
export const BigSecurityIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigSecurity, 'BigSecurity')
export const BigSnapIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigSnap, 'BigSnap')
export const BigSnapCrossedIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigSnapCrossed, 'BigSnapCrossed')
export const BigSnapEmptyIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigSnapEmpty, 'BigSnapEmpty')
export const BigTickIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigTick, 'BigTick')
export const BigTransferIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigTransfer, 'BigTransfer')
export const BigTwistoIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigTwisto, 'BigTwisto')
export const BigUnlockIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigUnlock, 'BigUnlock')
export const BigUserIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigUser, 'BigUser')
export const BigUserAddIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigUserAdd, 'BigUserAdd')
export const BigUserAttentionIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigUserAttention, 'BigUserAttention')
export const BigUserDeclineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigUserDecline, 'BigUserDecline')
export const BigUserDoneIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigUserDone, 'BigUserDone')
export const BigVerificationIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigVerification, 'BigVerification')
export const BigWarningIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigWarning, 'BigWarning')
export const BigWorldIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBigWorld, 'BigWorld')
